import useNodesProjectStore from '../stores/useNodesProjectStore';
import useNodesFeedStore from '../stores/useNodesFeedStore';

export function useNodesFlowSelectors() {
  const elements = useNodesProjectStore((s) => s.elements);
  const setElements = useNodesProjectStore((s) => s.setElements);
  const rule = useNodesProjectStore((s) => s.rule);
  const setRule = useNodesProjectStore((s) => s.setRule);
  const setNodesRf = useNodesProjectStore((s) => s.setNodesRf);
  const downloadStage = useNodesProjectStore((s) => s.downloadStage);
  const loadProject = useNodesProjectStore((s) => s.loadProject);
  const loadDesigns = useNodesProjectStore((s) => s.loadDesigns);
  const loadTemplates = useNodesProjectStore((s) => s.loadTemplates);
  const setRuleFetched = useNodesProjectStore((s) => s.setRuleFetched);
  const setProductFields = useNodesFeedStore((s) => s.setProductFields);

  return {
    elements,
    setElements,
    rule,
    setRule,
    setNodesRf,
    downloadStage,
    loadProject,
    loadDesigns,
    loadTemplates,
    setRuleFetched,
    setProductFields,
  };
}
